import { createContext, useContext, useMemo, useState } from 'react';
import { CONSTANT } from '../utils/constants';
import { useAccountContext } from './AccountContext';

const LanguageContext = createContext(null);

export const LanguageContextProvider = ({ children }) => {
  const [languageContext, setLanguageContext] = useState('fr');
  const { accountContext } = useAccountContext();

  const availableLanguages = useMemo(() => {
    if (!accountContext) return null;
    try {
      const { availableLanguages } = CONSTANT[accountContext.scope.slug];
      return CONSTANT.languages.filter((lang) => availableLanguages.includes(lang.key));
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [accountContext]);

  const currentLanguage = useMemo(() => {
    return CONSTANT.languages.find((lang) => lang.key === languageContext);
  }, [languageContext]);

  return (
    <LanguageContext.Provider
      value={{ languageContext, setLanguageContext, currentLanguage, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => {
  return useContext(LanguageContext);
};
